import CalendarDates from './CalendarDates'
import CalendarHeader from './CalendarHeader'
import CalendarMonthNavigation from './CalendarMonthNavigation'
import CalendarWeekdays from './CalendarWeekdays'

export default function Calendar({
  className,
  date,
  onDateClick,
  sessionDays,
}: {
  className?: string
  date: Date
  onDateClick: (date: Date, active?: boolean) => void
  sessionDays?: string[]
}): React.ReactElement {
  const handleOnDateClick = (newDate: Date): void => {
    onDateClick(newDate)
  }

  const handleOnNextMonthClick = (): void => {
    onDateClick(new Date(Date.UTC(date.getFullYear(), date.getMonth() + 1, 1)))
  }

  const handleOnPrevMonthClick = (): void => {
    onDateClick(new Date(Date.UTC(date.getFullYear(), date.getMonth() - 1, 1)))
  }

  return (
    <div className={`p-4 2xl:p-6 ${className}`}>
      <CalendarHeader selectedDate={date} />
      <div className="text-btn-sm">
        <CalendarWeekdays />
        <CalendarDates onDateClick={handleOnDateClick} selectedDate={date} sessionDays={sessionDays} />
      </div>
      <div className="mt-8">
        <CalendarMonthNavigation onNextMonthClick={handleOnNextMonthClick} onPrevMonthClick={handleOnPrevMonthClick} />
      </div>
    </div>
  )
}
